/* Info component on the ScriptScene Component */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoScriptScene = () => {
  return (
    <div>
      <Row className="mb-3">
        <Col md={{span: 8, offset: 2}}>
        <div className={`text-center px-3 py-2 ${styles.SubTitle6 } `}>
          <p className={`${styles.Red} text-center`}>INFO</p>
          <hr className={`mt-2 mb-0`}/>
        <p className='pt-2'><span className={`${styles.Red}`}>*</span> The Scene Script pages can be uploaded here.
          Only PDF files will be accepted.
        </p>
        <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoScriptScene